import React from "react";
import { Box, Typography } from "@mui/material";

interface CenteredCardProps {
    title?: string;
    children: React.ReactNode; // Allows the card to wrap any content
}

const CenteredListCard: React.FC<CenteredCardProps> = ({
    title = "",
    children
}) => {
    return (
        <Box sx={{ width: "100%" }}>
            <Box sx={{ backgroundColor: "background.default" }}>
                <Box
                    sx={{
                        width: "100%",
                        backgroundColor: { xs: "background.default", md: "background.paper" },
                        padding: 3,
                        borderRadius: { xs: 0, md: 2 },
                        boxShadow: { xs: "none", md: 3 },
                    }}
                >
                    <Typography
                        variant="h4"
                        sx={{ mb: 2, textAlign: "center", wordBreak: "break-all" }}
                    >
                        {title}
                    </Typography>
                    {children}
                </Box>
            </Box>
        </Box>

    );
};

export default CenteredListCard;
